import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

function mapStateToProps(state) {
  const { translation } = state;
  const { locale, messages } = translation;

  return {
    locale,
    key: locale,
    messages
  };
}

export default connect(mapStateToProps)(IntlProvider);